const p = (e, c) => fetch(e.replace("{ip}", c)).then((t) => t.json());
export {
  p as default
};
